export default __webpack_public_path__ + "static/media/martin_beetle.7f4acb3d.jpg";